var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFwd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/reply_all",
    transform: "matrix(-1,0,0,1,24,0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55856_43592",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#d9d9d9",
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55856_43592)",
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "reply_all",
    d: "m 8,17 -6,-6 6,-6 1.425,1.4 -4.6,4.6 4.6,4.6 z m 12,2 V 15 C 20,14.1667 19.7083,13.4583 19.125,12.875 18.5417,12.2917 17.8333,12 17,12 h -6.175 l 3.6,3.6 L 13,17 7,11 13,5 14.425,6.4 10.825,10 H 17 c 1.3833,0 2.5625,0.4875 3.5375,1.4625 C 21.5125,12.4375 22,13.6167 22,15 v 4 z",
    fill: "#5d49c7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwd);
export default __webpack_public_path__ + "static/media/fwd.f5e9c266fd217b77449b21c605677792.svg";
export { ForwardRef as ReactComponent };